import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2afa4e26"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "projects-section",
  id: "projects-section"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, "Projects", -1))
const _hoisted_3 = { class: "done-projects" }
const _hoisted_4 = {
  key: 0,
  class: "upcomming-projects"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "title" }, "Work in progress", -1))
const _hoisted_6 = { class: "items-container" }

import j_projects from '@/json/projects.json';
import Project from '@/types/Project.type';
import ProjectCard from '../ProjectCard.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectsSection',
  setup(__props) {

console.log("Mensaje sin importancia");

const projects: Project[] = j_projects.items;
const upcomming: Project[] = j_projects.developing;

return (_ctx: any,_cache: any) => {
  const _component_dis = _resolveComponent("dis")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_dis, {
      class: _normalizeClass(["displayer", { complete: _unref(upcomming).length <= 0 }])
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(projects), (p, idx) => {
            return (_openBlock(), _createBlock(ProjectCard, {
              key: idx,
              project: p
            }, null, 8, ["project"]))
          }), 128))
        ]),
        (_unref(upcomming).length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(upcomming), (p, idx) => {
                  return (_openBlock(), _createBlock(ProjectCard, {
                    key: idx,
                    project: p
                  }, null, 8, ["project"]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["class"])
  ]))
}
}

})